export default __webpack_public_path__ + "static/media/search-icon.c8c7097d.svg";